import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";
import CheckCircleIcon from "@ps-design-system/icons/CheckCircle/CheckCircle20";

const HostHubOverviewEmptyState = () => {
  return (
    <div className="tw-flex tw-items-center tw-gap-[8px]">
      <CheckCircleIcon className="tw-shrink-0 tw-text-purple-800" />
      <Text typeface="body-2">
        <FormattedMessage
          defaultMessage="You’re all caught up. Nice job!"
          id="host_hub.overview.todo_list.empty"
        />
      </Text>
    </div>
  );
};

export default HostHubOverviewEmptyState;
